import type { Client, RequestContext } from "../client";
import type { GitCredentialRepositoryRestrictionsResource, PaginatedCollection, SensitiveValue } from "../resources/index";
import type { PlatformHubGitCredentialResource } from "../resources/platformHubGitCredentialResource";
export class PlatformHubGitCredentialRepository {
    private client: Client;
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    create(gitCredential: CreatePlatformHubGitCredentialCommand) {
        return this.client.post<CreatePlatformHubGitCredentialResponse>(this.requestContext, "~/api/platformhub/git-credentials", gitCredential);
    }
    async get(args?: GetPlatformHubGitCredentialsRequest) {
        return await this.client.get<PaginatedCollection<PlatformHubGitCredentialResource>>(this.requestContext, "~/api/platformhub/git-credentials{?skip,take,name}", args);
    }
    async getById(gitCredentialId: string) {
        return await this.client.get<PlatformHubGitCredentialResource>(this.requestContext, "~/api/platformhub/git-credentials/{gitCredentialId}", { gitCredentialId });
    }
    async modify(gitCredential: ModifyPlatformHubGitCredentialCommand) {
        await this.client.put<ModifyPlatformHubGitCredentialResponse>(this.requestContext, "~/api/platformhub/git-credentials/{id}", gitCredential, { id: gitCredential.Id });
    }
    delete(gitCredentialId: string) {
        return this.client.del(this.requestContext, "~/api/platformhub/git-credentials/{id}", null, { id: gitCredentialId });
    }
}
export interface CreatePlatformHubGitCredentialCommand {
    Name: string;
    Description?: string;
    Details: NewGitCredentialDetails;
    RepositoryRestrictions?: GitCredentialRepositoryRestrictionsResource;
}
export interface NewGitCredentialDetails {
    Username: string;
    Password: SensitiveValue;
}
export interface CreatePlatformHubGitCredentialResponse {
    Id: string;
}
export type GetPlatformHubGitCredentialsRequest = {
    Skip?: number;
    Take?: number;
    Name?: string;
};
export interface ModifyPlatformHubGitCredentialCommand {
    Id: string;
    Name: string;
    Description?: string;
    Details: ModifyGitCredentialDetails;
    RepositoryRestrictions?: GitCredentialRepositoryRestrictionsResource;
}
export interface ModifyGitCredentialDetails {
    Username: string;
    Password: SensitiveValue;
}
export interface ModifyPlatformHubGitCredentialResponse {
}
export interface DeletePlatformHubGitCredentialResponse {
}
